import React, { useState, useRef, useEffect, useCallback } from "react";
import Carousel from "../UI/Carousel/Carousel";
import styles from "./SocialPostComponent.module.scss";
// import { formatFollowerCount } from "../../utils/constants";
import ReportModal from "../UI/ReportModal/ReportModal";
import ThreeDotsSVG from "../SVGComponents/ThreeDotsSVG";
import LikeSVG from "../SVGComponents/LikeSVG";
import CommentSVG from "../SVGComponents/CommentSVG";
import ShareSVG from "../SVGComponents/ShareSVG";
import { getTimeAgo, serverFiles, debounce } from "../../utils/utils";
import { API } from "service/Interceptor";
// import { formatFollowerCount } from "../../utils/constants";
import ShareLogos from "../SVGComponents/ShareLogos";
import { RxCross2 } from "react-icons/rx";
import CopyTextSVG from "../SVGComponents/CopyTextSVG";
import Linkify from "linkify-react";

import {
  likeAPost,
  commentAPost,
  getPostComments,
  unlikeAPost,
  deletePost,
  followUserPost,
  unfollowUserPost,
} from "../../reducer/postsSlice";
import { useDispatch, useSelector } from "react-redux";
import FlagSVG from "../SVGComponents/FlagSVG";
// import DeleteSVG from "../SVGComponents/DeleteSVG";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SendSVG from "../SVGComponents/SendSVG";
import SingleComment from "../SocialFeed/SingleComment/SingleComment";
import Suitcase from "../SVGComponents/Suitcase";
// import NoImageSVG from "../SVGComponents/NoImageSVG";
// import { API } from "../../service/Interceptor";
import DeleteSVG from "../SVGComponents/DeleteSVG";
// import Tooltip from "components/common/Tooltip/Tooltip.jsx";
import PlusIconSVG from "components/SVGComponents/PlusIconSVG";
import NoImageSVG from "components/SVGComponents/NoImageSVG";
import { useDisclosure } from "hooks";
import Modal from "components/Modal/Modal";
import LongDownArrow from "components/SVGComponents/LongDownArrow";
import Drawer from "components/Drawer/Drawer";
import Popup from "components/common/Popup/Popup";
import NO_IMAGE from "../../images/NO_IMAGE.jpg";

const shareLogos = (postURL) => {
  return [
    {
      type: "FACEBOOK",
      // URL: `https://www.facebook.com/sharer/sharer.php?u=${postURL}`,
      URL: `https://www.facebook.com`,
    },
    {
      type: "TWITTER",
      // URL: `https://twitter.com/intent/tweet?text=Check%20This%20Post&url=${postURL}`,
      URL: `https://twitter.com`,
    },
    {
      type: "INSTAGRAM",
      URL: "https://instagram.com",
    },
    {
      type: "WHATSAPP",
      // URL: `https://api.whatsapp.com/send?text=Check%20this%20Post%3A%20${postURL}`,
      URL: `https://api.whatsapp.com`,
    },
    {
      type: "TELEGRAM",
      // URL: `https://t.me/share/url?url=${postURL}&text=Check%20this%20Post!`,
      URL: `https://t.me`,
    },
  ];
};

const SocialPostComponent = ({ post }) => {
  // const likedBy = post.likedBy?.join(", ").toString();
  // const commentedBy = post.commentedBy?.join(", ").toString();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userProfile } = useSelector((state) => state.userProfile);

  const [readMore, setReadMore] = useState(false);
  const [postReportModal, setPostReportModal] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [threeDotsPopup, setThreeDotsPopup] = useState(false);
  const descRef = useRef(null);
  const [canToggle, setCanToggle] = useState(false);
  const [commentReply, setCommentReply] = useState(null);

  const [mentionActive, setMentionActive] = useState(false);
  const [mentionIndex, setMentionIndex] = useState(-1);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [mentions, setMentions] = useState([]);
  
  const textareaRef1 = useRef(null);
  const textareaRef2 = useRef(null);

  const mentionActiveRef = useRef(mentionActive);
  const searchQueryRef = useRef(searchQuery);

  useEffect(() => {
    mentionActiveRef.current = mentionActive;
    searchQueryRef.current = searchQuery;
  }, [mentionActive, searchQuery]);

  const isCompletedMention = (textAfterAt, mentionsList) => {
    return mentionsList.some(
      (m) => textAfterAt.startsWith(m.name + " ") || textAfterAt === m.name
    );
  };

  const handleInputChange = (val, selectionStart) => {
    const textBeforeCursor = val.slice(0, selectionStart);
    const lastAtIndex = textBeforeCursor.lastIndexOf("@");
    
    if (lastAtIndex !== -1) {
      const charBeforeAt = lastAtIndex > 0 ? textBeforeCursor[lastAtIndex - 1] : "";
      const textAfterAt = textBeforeCursor.slice(lastAtIndex + 1);
      
      if (lastAtIndex === 0 || /\s/.test(charBeforeAt)) {
        if (isCompletedMention(textAfterAt, mentions)) {
          setMentionActive(false);
          setSearchQuery("");
          return;
        }
        const spaceCount = (textAfterAt.match(/\s/g) || []).length;
        if (spaceCount <= 1 && !/[\n\r]/.test(textAfterAt) && !textAfterAt.startsWith(" ") && textAfterAt.length < 30) {
          setMentionActive(true);
          setMentionIndex(lastAtIndex);
          setSearchQuery(textAfterAt);
          return;
        }
      }
    }
    
    setMentionActive(false);
    setSearchQuery("");
  };

  const fetchSuggestions = useCallback(
    debounce(async (query) => {
      if (!query.trim()) {
        setSuggestions([]);
        return;
      }
      try {
        const res = await API.get(`/api/search?search=${query.toLowerCase()}`);
        const data = res?.data?.data?.userResponse || [];
        if (
          mentionActiveRef.current &&
          searchQueryRef.current.toLowerCase() === query.toLowerCase()
        ) {
          setSuggestions(data);
        }
      } catch (error) {
        console.error("Failed to fetch suggestions:", error);
        setSuggestions([]);
      }
    }, 200),
    []
  );

  useEffect(() => {
    if (mentionActive && searchQuery) {
      fetchSuggestions(searchQuery);
    } else {
      setSuggestions([]);
    }
  }, [searchQuery, mentionActive, fetchSuggestions]);

  const handleSelectSuggestion = (user, ref) => {
    const alias = user.userAliasId;
    const displayName = user.userType === "BUSINESS" && user.companyName 
      ? user.companyName 
      : `${user.firstName || ""} ${user.lastName || ""}`.trim();
    
    setMentions(prev => [...prev, { name: displayName, alias }]);
    
    const tag = `@${displayName}`;
    const textBeforeMention = comment.slice(0, mentionIndex);
    const textAfterCursor = comment.slice(ref.current.selectionStart);
    const newText = `${textBeforeMention}${tag} ${textAfterCursor}`;
    setComment(newText);
    setMentionActive(false);
    setSearchQuery("");
    setSuggestions([]);
    
    setTimeout(() => {
      if (ref.current) {
        ref.current.focus();
        const cursorPosition = textBeforeMention.length + tag.length + 1;
        ref.current.setSelectionRange(cursorPosition, cursorPosition);
      }
    }, 50);
  };

  useEffect(() => {
    if (!descRef.current) return;

    if (!readMore) {
      const el = descRef.current;
      setCanToggle(el.scrollHeight > el.clientHeight);
    }
  }, [post?.content, readMore]);

  console.log("User alias ID is", userProfile?.userAliasId);

  const {
    isOpen: commentsSection,
    close: closeCommentSection,
    open: openCommentSection,
    toggle: toggleCommentSection,
  } = useDisclosure();
  const [showComments, setShowComments] = useState(5);
  const [comment, setComment] = useState("");
  const [isSending, setIsSending] = useState(false);
  const shareBtnRef = useRef(null);
  const threeBtnRef = useRef(null);
  const popupRef = useRef(null);

  const postURL = `${window.location.origin}/posts/${post?.id}`;

  // Throttle logic to prevent multiple clicks within a short time
  const lastLikeRef = useRef(0);
  const lastFollowRef = useRef(0);
  const throttleDelay = 500;

  const followOtherUser = async (otherUserId, type) => {
    const now = Date.now();
    if (now - lastFollowRef.current >= throttleDelay) {
      lastFollowRef.current = now;

      const payload = {
        userAliasId: otherUserId,
      };
      try {
        if (type === "FOLLOW") {
          await dispatch(followUserPost({ payload, postId: post?.id }));
        } else if (type === "UNFOLLOW") {
          await dispatch(unfollowUserPost({ payload, postId: post?.id }));
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleAddComment = async (post) => {
    if (comment.trim() && !isSending) {
      setIsSending(true);
      try {
        let formatted = comment;
        mentions.forEach(m => {
          const safeName = m.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          const regex = new RegExp(`@${safeName}\\b`, 'g');
          formatted = formatted.replace(regex, `@[${m.name}](${m.alias})`);
        });

        const payload = {
          id: post?.id,
          comment: formatted,
        };
        await dispatch(commentAPost(payload)).unwrap();
        setComment("");
        setMentions([]);
        await dispatch(getPostComments({ id: post?.id })).unwrap();
      } catch (error) {
        console.error("Failed to add comment:", error);
      } finally {
        setIsSending(false);
      }
    }
  };

  // const handleDeletePost = async (id) => {
  //   try {
  //     // const res = await API.delete(`api/post/${id}`);
  //     // console.log(res);

  //     // if (res?.data?.success) {
  //     //   dispatch(getAllPosts());
  //     // }

  //     const res = dispatch(deletePost(id));
  //     console.log(res);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleToggleCommentSection = async () => {
    if (!commentsSection && !post?.comments) {
      await dispatch(getPostComments({ id: post?.id })).unwrap();
    }
    toggleCommentSection((prev) => !prev);
  };

  const handleLikeClick = () => {
    const now = Date.now();
    if (now - lastLikeRef.current >= throttleDelay) {
      if (!post?.isLiked) {
        dispatch(likeAPost(post?.id));
      } else {
        dispatch(unlikeAPost(post?.id));
      }
      lastLikeRef.current = now;
    }
  };

  const userAliasId = userProfile?.userAliasId;
  const companyAliasId = userProfile?.companyResponseDto?.companyAliasId;

  const isNotOwner =
    userAliasId !== post?.userAliasId && companyAliasId !== post?.userAliasId;

  // Close popup on outside click
  useEffect(() => {
    if (!showSharePopup) return;
    const handleClick = (e) => {
      if (
        shareBtnRef.current &&
        !shareBtnRef.current.contains(e.target) &&
        !document.getElementById("share-popup")?.contains(e.target)
      ) {
        setShowSharePopup(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showSharePopup]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        threeDotsPopup &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !threeBtnRef.current?.contains(event.target)
      ) {
        setThreeDotsPopup(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [threeDotsPopup]);

  return (
    <section className={styles.socialPost}>
      {/* <section className={styles.socialLikedBy}>
        <div className={styles.socialLikedByLeft}>

        </div>
      </section> */}

      <section className={styles.socialPostDetails}>
        <div className={styles.socialPostUserDetails}>
          <div className={styles.socialPost_left}>
            <Link
              to={
                post?.userAliasId === userAliasId ||
                post?.userAliasId === companyAliasId
                  ? `/user-profile`
                  : `/user-profile/${post?.userAliasId}`
              }
              className={`${styles.userDetailsLeft} unstyledLink`}
            >
              {post?.postOwner?.profileUrl ? (
                <img
                  alt=""
                  src={serverFiles(post?.postOwner?.profileUrl) || NO_IMAGE}
                  className={styles.profileImage}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = NO_IMAGE;
                  }}
                />
              ) : (
                <NoImageSVG type="profile" height="40" width="40" />
              )}
              <div className={styles.userDetails}>
                <p className={styles.postUserTitle}>
                  {post?.postOwner?.firstName} {post?.postOwner?.lastName}
                  <span className={styles.suitcase}>
                    {post?.postOwner?.userType === "BUSINESS" && (
                      <Suitcase height="14" width="14" />
                    )}{" "}
                  </span>
                  <span className={styles.times_ago}>
                    | {getTimeAgo(post?.createdAt)}
                  </span>
                </p>
                {/* <p className={styles.postUserDesignation}>
                {post?.postOwner?.industry.join(", ").slice(0, 20)}... |{" "}
                {formatFollowerCount(post?.postOwner?.followerCount)} followers
              </p> */}
              </div>
            </Link>
            <div className={styles.userFollowBtn}>
              {isNotOwner ? (
                !post?.isFollowed ? (
                  <div
                    className={styles.follow_btn}
                    onClick={() => followOtherUser(post?.userAliasId, "FOLLOW")}
                  >
                    <PlusIconSVG fill="#6570FC" />
                    <p>Follow</p>
                  </div>
                ) : (
                  <div
                    className={styles.follow_btn}
                    onClick={() =>
                      followOtherUser(post?.userAliasId, "UNFOLLOW")
                    }
                  >
                    Following
                  </div>
                )
              ) : null}
            </div>
          </div>

          <div>
            <div className={styles.socialLikedByRight}>
              <ThreeDotsSVG
                onClick={() => {
                  setThreeDotsPopup((prev) => !prev);
                }}
              />

              {threeDotsPopup && (
                <>
                  <div
                    ref={threeBtnRef}
                    className={styles.dropdown_overlay}
                    onClick={() => setThreeDotsPopup(false)}
                  />

                  <section ref={popupRef} className={styles.three_dots_popup}>
                    <div
                      onClick={() => {
                        setThreeDotsPopup(false);
                        setPostReportModal(true);
                      }}
                      className={styles.single_btn_section}
                    >
                      <FlagSVG height={18} width={18} color="black" />

                      <p className={styles.single_button}>Report this post</p>
                    </div>

                    {!isNotOwner && (
                      <>
                        <hr className={styles.seperator} />
                        <div
                          className={styles.single_btn_section}
                          onClick={() => {
                            dispatch(deletePost(post?.id));
                            navigate("/feed");
                            setThreeDotsPopup(false);
                          }}
                        >
                          <DeleteSVG height={18} width={18} />
                          <p className={styles.single_button}>
                            Delete this post
                          </p>
                        </div>
                      </>
                    )}
                    {/* <div className={styles.single_btn_section}>
                <DeleteSVG height={18} width={18} />
                <p className={styles.single_button}>Delete</p>
              </div> */}
                  </section>
                </>
              )}
            </div>

            <ReportModal
              type="Post"
              id={post?.id}
              reportModal={postReportModal}
              setReportModal={setPostReportModal}
            />
          </div>
        </div>

        <div className={styles.socialPostContent}>
          {/* DESCRIPTION WILL BE SHOWN ALL THE TIME */}
          {post?.tags[0] !== "" && (
            <div className={styles.selected_tag}>{post?.tags[0]}</div>
          )}

          <div className={styles.postDescriptionWrapper}>
            <p
              ref={descRef}
              className={`${styles.postDescription} ${
                !readMore ? styles.truncated : ""
              }`}
            >
              <Linkify
                options={{
                  target: "_blank",
                  rel: "noopener noreferrer",
                }}
              >
                {post?.content}
              </Linkify>
            </p>

            {canToggle && (
              <span
                className={styles.readMoreToggle}
                onClick={() => setReadMore((prev) => !prev)}
              >
                {readMore ? "HIDE CONTENT" : "READ MORE"}
              </span>
            )}
          </div>

          {/* IMAGES WILL BE SHOWN IF THEY ARE PRESENT IN THE ARRAY */}
          {post?.medias?.length > 0 ? (
            <div className={styles.postImages}>
              <Carousel
                isLiked={post?.isLiked}
                medias={post?.medias}
                postId={post?.id}
              />
            </div>
          ) : null}
        </div>
      </section>

      <section className={styles.socialLikesComments}>
        <div className={styles.likesCommentsLeft}>
          <button onClick={handleLikeClick} className={styles.likeBtn}>
            <LikeSVG liked={post?.isLiked} />
            {post?.likeCount > 0 && post?.likeCount}
          </button>
          <button
            onClick={handleToggleCommentSection}
            className={styles.commentBtn}
          >
            <CommentSVG />
            {post?.commentCount > 0 && post?.commentCount}
          </button>
        </div>
        <div
          className={styles.likesCommentsRight}
          style={{ position: "relative" }}
        >
          <button
            ref={shareBtnRef}
            onClick={() => setShowSharePopup((prev) => !prev)}
            className={styles.shareBtn}
          >
            <ShareSVG height={16} width={16} text={postURL} />
            Share
          </button>
          <Popup
            open={showSharePopup}
            onClose={() => setShowSharePopup(false)}
            anchorRef={shareBtnRef}
            id="share-popup"
            position="top"
            minVisibleWidth={480} // example: minimum width in px
          >
            <>
              <div className={styles.share_popup_heading}>
                <p className={styles.share_heading}>Share</p>
                {/* <RxCross2
                  fontSize={20}
                  onClick={() => setShowSharePopup(false)}
                  style={{ cursor: "pointer" }}
                /> */}
              </div>
              <div className={styles.share_logos}>
                {shareLogos(postURL)?.map((logo, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      window.open(logo.URL);
                    }}
                  >
                    <ShareLogos name={logo.type} />
                  </div>
                ))}
              </div>
              <div className={styles.post_copy_link}>
                <p className={styles.copy_link_heading}>Link</p>
                <div className={styles.copyPostText}>
                  <p className={styles.copyText}>{postURL}</p>
                  <p className={styles.copy_svg}>
                    <CopyTextSVG
                      text={postURL}
                      success="Link Copied"
                      error="Cannot Copy Link"
                      height={20}
                      width={20}
                      color="black"
                    />
                  </p>
                </div>
              </div>
            </>
          </Popup>
        </div>
      </section>

      {commentsSection && (
        <div className={styles.comments_responsive}>
          <section className={styles.comments_section}>
            <div className={styles.mention_suggestions_container}>
              <section className={styles.comments_input_section}>
                <textarea
                  ref={textareaRef1}
                  className={styles.comment_textarea}
                  name=""
                  id=""
                  rows={1}
                  value={comment}
                  onChange={(e) => {
                    const val = e.target.value;
                    setComment(val);
                    handleInputChange(val, e.target.selectionStart);
                  }}
                  placeholder="Comment"
                />
                <div className={styles.close_send_icons}>
                  <button
                    onClick={() => handleAddComment(post)}
                    className={styles.postButton}
                    disabled={isSending || !comment.trim()}
                  >
                    {isSending ? (
                      <span className={styles.btn_spinner}></span>
                    ) : (
                      <SendSVG />
                    )}
                  </button>
                </div>
              </section>
              {mentionActive && suggestions.length > 0 && (
                <div className={styles.mention_suggestions_dropdown}>
                  {suggestions.map((user) => {
                    const name = user.userType === "BUSINESS" && user.companyName 
                      ? user.companyName 
                      : `${user.firstName || ""} ${user.lastName || ""}`.trim();
                    return (
                      <div
                        key={user.userAliasId}
                        className={styles.suggestion_item}
                        onClick={() => handleSelectSuggestion(user, textareaRef1)}
                      >
                        <div className={styles.suggestion_user_image}>
                          {user.profileUrl ? (
                            <img
                              src={serverFiles(user.profileUrl)}
                              alt="user profile"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = NO_IMAGE;
                              }}
                            />
                          ) : (
                            <NoImageSVG type="profile" height="32" width="32" />
                          )}
                        </div>
                        <div className={styles.suggestion_user_info}>
                          <span className={styles.suggestion_user_name}>{name}</span>
                          <span className={styles.suggestion_user_alias}>@{user.userAliasId}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <section className={styles.comments_heading}>
              <p>Comments</p>
              <p className={styles.comments_count}>{post?.commentCount || 0}</p>
            </section>

            {post?.comments?.length ? (
              <div className={styles.comments_section_wrapper}>
                <div className={styles.comments_array}>
                  {post?.comments
                    ?.slice(0, showComments)
                    .map((comment, index) => {
                      return (
                        <SingleComment
                          key={comment?.id}
                          post={post}
                          comment={comment}
                          commentToReply={commentReply}
                          setCommentToReply={setCommentReply}
                        />
                      );
                    })}
                </div>
                {post?.comments?.length > showComments && (
                  <div
                    className={styles.comments_show_all}
                    onClick={() => setShowComments((prev) => prev + 5)}
                  >
                    <LongDownArrow />
                    <p>Show More</p>
                  </div>
                )}
              </div>
            ) : (
              <>
                <p className={styles.no_comments}>No comments found </p>
              </>
            )}
          </section>
        </div>
      )}
      <Modal
        shadowClassName={styles.commentsModal}
        shouldBlock={false}
        height="fit-content"
        background="white"
        heading="Comments"
        headerClassName={styles.commentModalHeader}
        modalOpen={commentsSection}
        onClose={closeCommentSection}
        drawer={{
          isDrawer: true,
          position: "bottom",
          mobileOnly: true,
        }}
      >
        <section className={styles.comments_section}>
          <div className={styles.mention_suggestions_container}>
            <section className={styles.comments_input_section}>
              <img
                className={styles.comment_user_image}
                src={serverFiles(userProfile?.profileUrl) || NO_IMAGE}
                alt="owner profile"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
              />
              <textarea
                ref={textareaRef2}
                className={styles.comment_textarea}
                name=""
                id=""
                rows={4}
                value={comment}
                onChange={(e) => {
                  const val = e.target.value;
                  setComment(val);
                  handleInputChange(val, e.target.selectionStart);
                }}
                placeholder="Comment"
              />
              <div className={styles.close_send_icons}>
                <button
                  onClick={() => handleAddComment(post)}
                  className={styles.postButton}
                  disabled={isSending || !comment.trim()}
                >
                  {isSending ? (
                    <span className={styles.btn_spinner}></span>
                  ) : (
                    <SendSVG />
                  )}
                </button>
              </div>
            </section>
            {mentionActive && suggestions.length > 0 && (
              <div className={styles.mention_suggestions_dropdown}>
                {suggestions.map((user) => {
                  const name = user.userType === "BUSINESS" && user.companyName 
                    ? user.companyName 
                    : `${user.firstName || ""} ${user.lastName || ""}`.trim();
                  return (
                    <div
                      key={user.userAliasId}
                      className={styles.suggestion_item}
                      onClick={() => handleSelectSuggestion(user, textareaRef2)}
                    >
                      <div className={styles.suggestion_user_image}>
                        {user.profileUrl ? (
                          <img
                            src={serverFiles(user.profileUrl)}
                            alt="user profile"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = NO_IMAGE;
                            }}
                          />
                        ) : (
                          <NoImageSVG type="profile" height="32" width="32" />
                        )}
                      </div>
                      <div className={styles.suggestion_user_info}>
                        <span className={styles.suggestion_user_name}>{name}</span>
                        <span className={styles.suggestion_user_alias}>@{user.userAliasId}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <section className={styles.comments_heading}>
            <p>Comments</p>
            <p className={styles.comments_count}>{post?.commentCount || 0}</p>
          </section>

          {post?.comments?.length ? (
            <div className={styles.comments_section_wrapper}>
              <div className={styles.comments_array}>
                {post?.comments
                  ?.slice(0, showComments)
                  .map((comment, index) => {
                    return (
                      <SingleComment
                        key={index}
                        post={post}
                        comment={comment}
                        commentToReply={commentReply}
                        setCommentToReply={setCommentReply}
                      />
                    );
                  })}
              </div>
              {post?.comments?.length > showComments && (
                <div
                  className={styles.comments_show_all}
                  onClick={() => setShowComments((prev) => prev + 5)}
                >
                  <LongDownArrow />
                  <p>Show More</p>
                </div>
              )}
            </div>
          ) : (
            <>
              <p className={styles.no_comments}>No comments found </p>
            </>
          )}
        </section>
      </Modal>

      <Drawer
        shadowClassName={styles.mobile_drawer_container}
        bodyClassName={styles.mobile_drawer_body}
        drawerOpen={showSharePopup}
        onClose={() => setShowSharePopup(false)}
        width="100vw"
        position="bottom"
        heading="Share"
      >
        <div className={styles.share_logos} key="mobile">
          {shareLogos(postURL)?.map((logo, index) => (
            <div
              key={index}
              onClick={() => {
                window.open(logo.URL);
              }}
            >
              <ShareLogos name={logo.type} />
            </div>
          ))}
        </div>
        <div className={styles.post_copy_link}>
          <p className={styles.copy_link_heading}>Post Link</p>
          <div className={styles.copyPostText}>
            <p className={styles.copyText}>{postURL}</p>
            <p className={styles.copy_svg}>
              <CopyTextSVG
                text={postURL}
                success="Link Copied"
                error="Cannot Copy Link"
                height={20}
                width={20}
                color="black"
              />
            </p>
          </div>
        </div>
      </Drawer>
    </section>
  );
};

export default SocialPostComponent;
